module.exports = __webpack_public_path__ + "static/media/5.2e431fc3.PNG";